import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import AdminPanel from "@/pages/AdminPanel";

function isMaster(user) {
  return user && (user.role === "master" || user.role === "admin");
}

export default function AdminPanelUnified() {
  const [tabHost, setTabHost] = useState(null);
  const user = JSON.parse(sessionStorage.getItem("mod_user") || "null");

  useEffect(() => {
    let frame = null;

    const findTabHost = () => {
      const host = document.querySelector("[data-testid='admin-tabs']");
      if (host) {
        setTabHost(host);
        return;
      }
      frame = window.requestAnimationFrame(findTabHost);
    };

    findTabHost();
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <>
      <AdminPanel />
      {tabHost && isMaster(user) && createPortal(
        <Link
          to="/mod/bygdepuls"
          data-testid="mod-bygdepuls-link"
          className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-md transition-all text-muted-foreground hover:bg-bone-alt no-underline"
          title="Bygdepuls"
        >
          <Newspaper size={16} /> Bygdepuls
        </Link>,
        tabHost,
      )}
    </>
  );
}
